import axios from 'axios';

const api = axios.create({
    //    baseURL: 'http://localhost:3333/',
   baseURL: 'https://api.bomstar.com.br/',
});

export default api;